import { lazy } from "react";
import { Database } from "lucide-react";
import type { AdminModule } from "../types";

const Indices = lazy(() => import("./pages/Indices").then((m) => ({ default: m.Indices })));
const Jobs = lazy(() => import("./pages/Jobs").then((m) => ({ default: m.Jobs })));

/**
 * Was "Infra" at /infra/opensearch/*, which promised a whole infrastructure
 * console and delivered two OpenSearch screens. The label and the route now
 * say what it actually is; /infra/opensearch/* still redirects here.
 */
export const searchModule: AdminModule = {
  key: "search",
  label: "Search indexing",
  description: "OpenSearch index health and the reindex/backfill job board.",
  group: "operations",
  icon: Database,
  requiredPermission: "admin.infra.opensearch.read",
  routes: [
    { path: "indices", label: "Indices", element: <Indices /> },
    { path: "jobs", label: "Reindex jobs", element: <Jobs /> },
  ],
};
